var moment = require('moment');

var Constants = require('../../constants/Constants');
var Ip = require('../../util/Ip');
var BaseStore = require('../BaseStore');

var BandwidthHistogramStore = new BaseStore({
    defaultData: {}
});

BandwidthHistogramStore.getBandwidth = function (service) {
    if (!this._data.hasOwnProperty(service.id)) {
        this._loading = true;
        this._data[service.id] = null;
        this.emitChange();

        var Api = require('../../api/Invocation');

        var promise = Api.bandwidth.getHistoricalBandwidth(
            service,
            Ip.usageIps(service),
            moment(service.transit.next_usage_period).format('YYYY-MM-DD'),
            moment().subtract(6, 'months').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
        );

        promise
            .then(({ body }) => this._data[service.id] = body.periods)
            .then(() => this._loading = false)
            .then(() => this.promiseChange())
            .done();
    }

    return this._data[service.id];
};

module.exports = BandwidthHistogramStore;



// WEBPACK FOOTER //
// ./app/stores/Bandwidth/HistogramStore.js